import { type PropType, defineComponent } from 'vue'
import NewsExtraInfo from '../NewsExtraInfo'
import Image from './Image'

import './style.less'

export default defineComponent({
  props: {
    coverStyle: {
      type: Object as PropType<{
        width?: number;
        height?: number;
      }>,
      default: () => {
        return { width: 0, height: 0 }
      }
    },
    width:  [ Number, String ] as PropType<number | string>,
    height: [ Number, String ] as PropType<number | string>,
    url: String as PropType<string>,
    alt: {
      type: String as PropType<string>,
      default: `People's Daily English language App - Homepage - Breaking News, China News, World News and Video`
    },
    isDark: Boolean as PropType<boolean>,
    record: Object as PropType<NewsItem>,
    mobile: Boolean as PropType<boolean>,
    blur: {
      type: Boolean as PropType<boolean>,
      default: true
    },
  },
  setup(props) {
    const unit = computed(() => props.mobile ? 'rem' : 'px')

    const loaded = ref(false)

    const imageBlurUrl = computed(() => loaded.value ? props.url : '')

    const hasBlur = computed(() => {
      if (props.coverStyle?.width && props.coverStyle?.height && props.height && props.width) {
        return !((props.coverStyle?.width / props.coverStyle?.height) === ((props.width as any) / (props.height as any)))
      }
      return true
    })

    return () => {
      return (
        <div
          class={[ 'en-preview-image', props.mobile ? 'mobile' : '', props.blur && hasBlur.value ? 'preview-blur' : '' ]}
          style={props.blur && hasBlur.value ? {
            backgroundImage: loaded.value ? `url('${imageBlurUrl.value}')` : undefined,
            width: `${props.width}${unit.value}`,
            height: props.height ? `${props.height}${unit.value}` : '100%'
          } : undefined}
        >
          <Image
            width={props.width}
            height={props.height}
            mobile={props.mobile}
            isDark={props.isDark}
            url={props.url}
            alt={props.alt}
            onLoad={() => loaded.value = true}
          />
          <NewsExtraInfo
            absolute
            mobile={props.mobile}
            type={Number(props.record?.objectType) as NewsType}
            videoInfo={props.record?.videoInfo}
            liveInfo={props.record?.liveInfo}
            photoNum={props.record?.photoNum}
          />
        </div>
      )
    }
  }
})
